import { Component, OnDestroy, ViewChild, OnInit, Input } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs';
import {
  debounceTime,
  takeUntil,
  distinctUntilChanged,
  tap,
  map,
} from 'rxjs/operators';
import {
  ChatService,
  FinanceService,
  OrganizationService,
} from '../../services';
import { environment } from 'src/environments/environment';
import { AppFilter, ConfirmModal, ChatDocumentModal } from 'src/modules/shared';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SuiModal,
  ModalTemplate,
  TemplateModalConfig,
  SuiModalService,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import {
  FormBuilder,
  FormControl,
  Validators,
  FormGroup,
  FormControlName,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}

interface IDynamicFormContext {
  formStructure: Array<any>;
  formTitle?: string;
  formAction?: string;
  companyTypeOptions?: any;
  prbsOptions?: Array<any>;
}

interface ComplaintMessageView {
  messageId?: string;
  messageBody?: string;
  parentMessageId?: string;
  createdByOrganizationId?: string;
  allowContractorToRespond?: boolean;
  contractorResponded?: boolean;
  dateCreated?: string;
  createdBy?: string;
  complaintId?: string;
  resolvedPath?: string;
  level?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  organizationShortName?: string;
  organizationLongName?: string;
  logoPath?: string;
  organizationTypeId?: string;
  fileName: string;
  filePath: string;
  fileDescription: string;
  extension: string;
  extensionGroup: string;
}

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent implements OnInit {
  @Input() objectId: string;

  isAdmin: boolean;
  successMessage;
  messageIndex;
  collapse = false;
  replyBlock;
  createPending: boolean;
  createError: string;
  success: string;
  error: any;
  organization: any;
  user: any;
  organizationId: string;
  complaintId: string;
  messages: Array<any> = [];
  pending: boolean;
  total;
  page;
  records;

  maxSize = 5;
  requireDocs = [];
  documents: any[] = [];
  documentsType: any[];
  attachment = false;
  attachmentSuccess = false;
  removeAttachemt: boolean;
  fileError: any;
  selectedFile: any;

  replyForm: FormGroup;
  fileObj: any;
  fileName: string;

  messageParams: AppFilter;
  searchMessagesFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'level',
        op: 'eq',
        data: 0,
      },
    ],
  };

  baseUrl = environment.API_SERVER;

  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'contractor_relevant_docs',
      },
    ],
  };
  uploadFormData: any = new FormData();
  isReply: any;
  allowContractorToRespond: boolean = true;
  file: any;
  newComment: boolean;
  private unsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    private modalService: SuiModalService,
    private activatedRoute: ActivatedRoute,
    private commentSvc: ChatService,
    private _complaintsSrv: ChatService,
    private fb: FormBuilder,
    private userService: OrganizationService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private commentService: FinanceService
  ) {
    console.log('objectid', this.objectId);
    this.getOptionTypes();
    this.replyForm = fb.group({
      comment: ['', Validators.required],
      hideFromApplicant: [false],
    });

    if (window.localStorage.getItem('isAdmin')) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }

    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.user = JSON.parse(window.localStorage.getItem('user'));
    if (this.user && this.user.image) {
      this.user.image = `${
        this.baseUrl
      }/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
    } else {
      this.user.image = 'assets/avatar/1.jpg';
    }

    // this.messageParams = new AppFilter({ sidx: 'dateCreated', rows: 4, sord: 'asc' });
    this.messageParams = new AppFilter({
      sidx: 'position',
      rows: 4,
      sord: 'desc',
    });
    // this.searchMessagesFilter.rules[0].data = 0;
    // this.messageParams.filters = JSON.stringify(this.searchMessagesFilter);

    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((params) => {
        this.complaintId = params['id'];
        this.messages = [];
        this.getPage(1);
      });

    this._complaintsSrv
      .getRefreshMessages()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.messages = [];
        // this.getMessages(this.messageParams.page);
      });
  }

  onReply(event) {
    console.log(event);
    // this.replyForm.get('messageBody').patchValue('Reply to comment');
    this.isReply = event;
  }
  removeReply() {
    this.isReply = null;
  }
  removeFile() {
    this.fileObj = null;
    this.uploadFormData = new FormData();
  }
  showReplyForm(form) {
    this.replyBlock = form;
  }

  getPage(page) {
    this.messageParams.page = page;
    this.pending = true;
    if(this.isEWalletChat()==false)
    {
      this.commentSvc
        .getMessage({
          organizationId: this.organization.organizationId,
          params: this.messageParams,
        })
        .pipe(
          map((result) => {
            result['rows'].forEach((comment) => {
              comment['documentMetadata'] = comment['documentMetadata']
                ? JSON.parse(comment['documentMetadata'])
                : null;
            });
            return result['rows'];
          })
        )
        .subscribe(
          (res) => {
            this.pending = false;
            res.forEach((comment) => {
              comment.comment = comment.comment.replace(
                /&(?:[a-z\d]+|#\d+|#x[a-f\d]+);/gi,
                ''
              );
              this.messages.unshift(comment);
            });
            console.log(this.messages, 'messages');
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
              : error.error ? error.error
                : error;
          }
        );
    } else {
      console.log('fetching ewallet messages');
        this.commentService
          .getCommentsById({
            objectId: this.objectId || localStorage.getItem('objectId'),
            params: this.messageParams,
          })
          .pipe(
            map((result) => {
              result['rows'].forEach((comment) => {
                if (comment.objectType == ('WITHDRAWAL_REQUEST' || 'BANK_HISTORY')) {
                  comment['documentMetadata'] = comment['documentMetadata']
                    ? JSON.parse(comment['documentMetadata'])
                    : null;
                }
              });
              return result['rows'];
            })
          )
          .subscribe(
            (res) => {
              this.pending = false;
              res.forEach((comment) => {
                comment.comment = comment.comment.replace(
                  /&(?:[a-z\d]+|#\d+|#x[a-f\d]+);/gi,
                  ''
                );
                this.messages.unshift(comment);
              });
              console.log(this.messages, 'ewallet messages');
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage ? error.error.errorMessage
                : error.error ? error.error
                  : error;
            }
          );
    }
  }
  onScrollDown($event) {}

  onScrollUp($event) {
    if (!this.newComment) {
      let page = this.messageParams.page + 1;
      this.getPage(page);
    }
  }

  download(payload) {
    const url = `${this.baseUrl}/public/media/?media=${payload.filePath}`;
    window.open(url, '_blank');
  }

  isEWalletChat(){
    let isewallet;
    if (this.router.url.includes('/contractor/wallet/')) {
      console.log(true);
        isewallet = true;
      } else {
        isewallet = false;
      }
    return isewallet;
  }

  getMonitoringMessages(page) {
    this.messageParams.sord = 'asc';
    this.messageParams.page = page;
    this.pending = true;
    if (this.isEWalletChat() == false)
    {
      this._complaintsSrv
        .getAllComplaintMessagesView({
          organizationId: this.organization.organizationId,
          complaintId: this.complaintId,
          params: this.messageParams,
        })
        .pipe(
          tap((res: any) => {
            this.total = +res['records'];
            this.page = page;
            this.records = +this.messageParams.rows;
          }),
          map((res: any) => res.rows),
          takeUntil(this.unsubscribe$)
        )
        .subscribe(
          (res: ComplaintMessageView[]) => {
            this.pending = false;
            this.messages = res;
            console.log(this.messages, 'messages');
          },
          (error) => {
            this.pending = false;
            this.error = error;
          }
        );
    } else {
      // ewallet messages fetch
      this.commentService
        .getCommentsById({
          objectId: this.objectId,
          params: this.messageParams,
        })
        .pipe(
          tap((res: any) => {
            this.total = +res['records'];
            this.page = page;
            this.records = +this.messageParams.rows;
          }),
          map((res: any) => res.rows),
          takeUntil(this.unsubscribe$)
        )
        .subscribe(
          (res: any) => {
            this.pending = false;
            this.messages = res;
            console.log(this.messages, 'ewallet refetch');
          },
          (error) => {
            this.pending = false;
            this.error = error;
          }
        );
    }
  }
  send() {
    if (this.replyForm.valid) {
      // console.log(this.filterMetaData);
      const formData = new FormData();
      if (this.fileObj) {
        formData.append('file', this.fileObj);
      }
      let data = this.replyForm.value;

    if(this.isEWalletChat()==true){
      if (this.router.url.includes('/contractor/wallet/withdrawal-request')) {
        data['objectType'] = 'WITHDRAWAL_REQUEST';
      } else if (this.router.url.includes('/contractor/wallet/bank-change-request')) {
        data['objectType'] = 'BANK_HISTORY';
      }
      data['hideFromApplicant'] = null;
    }
    data.comment = data.comment.replace(/(<([^>]+)>)/gi, '');
    data.comment = data.comment.replace(
      /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,
      ' '
    );
    if (this.isReply) {
      data['parentCommentId'] = this.isReply.commentId;
    }

      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });

    // console.log(this.hideFromApplicant);
    formData.append('data', blob);
    this.pending = true;
    if(this.isEWalletChat()==false) {
      this.commentSvc
      .createComplaint({
        organizationId: this.organization.organizationId,
        body: formData,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          res['documentMetadata'] = res['documentId']
            ? JSON.parse(res['documentMetadata'])
            : '';
          this.messages.push(res);
          this.fileObj = null;
          this.isReply = null;
          this.replyForm.reset();
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
            : error.error ? error.error
              : error;
        }
      );
    } else {
        console.log('send from ewallet');
        this.commentService
          .makeCommentById({
            objectId: this.objectId || localStorage.getItem('objectId'),
            body: formData,
          })
          .subscribe(
            (res) => {
              this.pending = false;
              res['documentMetadata'] = res['documentId']
                ? JSON.parse(res['documentMetadata'])
                : '';
              this.messages.push(res);
              this.fileObj = null;
              this.isReply = null;
              this.replyForm.reset();
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage ? error.error.errorMessage
                : error.error ? error.error
                  : error;
            }
          );
      }
    }
  }
  // send() {
  // 	// console.log(this.filterMetaData);

  // 	let data = this.replyForm.value;
  // 	if (this.isReply) {
  // 		data['parentCommentId'] = this.isReply.commentId;
  // 	}
  // 	let comment = data.comment;
  // 	data.comment = comment;
  // 	const blob = new Blob([ JSON.stringify(data, null, 2) ], { type: 'application/json' });

  // 	// console.log(this.notifyApplicant);
  // 	let uploadData =new FormData()
  // 	uploadData.append
  // 	this.uploadFormData.append('data', blob);

  // 	this.pending = true;
  // 	this.commentSvc
  // 		.createComplaint({
  // 			organizationId: this.organization.organizationId,
  // 			body: this.uploadFormData
  // 		})
  // 		.subscribe(
  // 			(res) => {
  // 				this.pending = false;
  // 				res['documentMetadata'] = res['documentId'] ? JSON.parse(res['documentMetadata']) : '';
  // 				this.messages.push(res);
  // 				this.isReply = null;
  // 				this.replyForm.reset();
  // 			},
  // 			(error) => {
  // 				this.pending = false;
  // 				this.error = error.error ? error.error : error;
  // 			}
  // 		);
  // }

  sendd(id) {
    let parentComplaintMessage;
    if (id === 'null') {
      parentComplaintMessage = '';
    } else {
      parentComplaintMessage = id;
    }
    this.pending = true;
    if (this.replyForm.valid) {
      const values = this.replyForm.value;
      const jsonse = JSON.stringify(values);
      const blob = new Blob([jsonse], { type: 'application/json' });
      this.uploadFormData.append('data', blob);
      this._complaintsSrv
        .createComplaint({
          organizationId: this.organization.organizationId,
          complaintId: this.complaintId,
          body: this.uploadFormData,
          parentComplaintMessage: parentComplaintMessage,
        })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Message sent sucessfully';
            this.isReply = null;
            this.getPage(1);
            this._complaintsSrv.setRefreshApproval('');
            this.replyForm.reset();
            this.uploadFormData = null;
            this.file = null;
            this.attachmentSuccess = false;
            this.removeAttachemt = false;
          },
          (error) => {
            this.pending = false;
            this.error = error;
          }
        );
    }
  }

  ngOnDestroy() {}

  ngOnInit() {
    console.log(this.isEWalletChat(), "isEWalletChat");
  }

  uploadDocument() {}

  // uploadDoc() {
  // 	this.modalService
  // 		.open(new ChatDocumentModal('Attach document?', this.documentsType, ModalSize.Tiny))
  // 		.onApprove((payload: any) => {
  // 			this.file = payload['formData'];
  // 			this.uploadFormData = payload['formData'];
  // 			this.replyForm.patchValue(payload['formValue']);
  // 		})
  // 		.onDeny(() => {});
  // }
  // Send doucment methods

  uploadDoc($event) {
    this.fileObj = $event[0];
    this.fileName = this.fileObj['name'];
  }

  onFileChange(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.selectedFile = files[0];
  }

  fileUpload() {
    const formData: FormData = new FormData();
    this.documents.forEach((doc) => {
      if (this.requireDocs.indexOf(doc.documentName)) {
        formData.append(doc.documentName, doc.file, doc.file.name);
      }
    });
    return formData;
  }

  getOptionTypes() {
    this.userService
      .getOptions({ filter: JSON.stringify(this.optionFilter) })
      .pipe(
        takeUntil(this.unsubscribe$),
        map((res) => res['rows']),
        map((res: any) => {
          const options = {
            ownershipType: [],
            documentType: [],
            companyType: [],
            errorOption: [],
            providerType: [],
          };
          res.forEach((option) => {
            switch (option.optionType.optionTypeId) {
              case 'contractor_relevant_docs':
                options.documentType.push(option);
                break;
              case 'ownership_type':
                options.ownershipType.push(option);
                break;
              case 'actual_company_type':
                options.companyType.push(option);
                break;
              case 'foreign_company_providers':
                options.providerType.push(option);
                break;
              default:
                options.errorOption.push(option);
            }
          });
          return options;
        })
      )
      .subscribe(
        (res) => {
          this.documentsType = res.documentType;
          this.documentsType.push({
            optionId: 'OTHERS',
            optionName: 'Other',
            optionDescription: '{required:false}',
          });
        },
        (error) => {}
      );
  }

  prepareRequireDocs() {
    this.documentsType.forEach((docs) => {
      const parsedDescription = JSON.parse(docs.optionDescription);
      if (parsedDescription && parsedDescription.required === true) {
        this.requireDocs[docs.optionId] = docs.optionName;
      }
    });
  }
}
